import { useMutation } from '@tanstack/react-query';
import { apiClient } from 'api';
import { useToast } from 'hooks/useToast';

/**
 * Interface for request reset password payload
 */
export interface RequestResetPasswordPayload {
  email: string;
}

/**
 * Hook for requesting password reset link using TanStack React Query
 */
export const useRequestResetPassword = (
  setSuccess: (value: boolean) => void,
  setEmail: (value: string) => void
) => {
  const { openToast } = useToast();

  return useMutation({
    mutationFn: async (payload: RequestResetPasswordPayload) => {
      const response = await apiClient.get<void>('/auth/reset-password/', {
        params: { email: payload.email },
      });
      return response.data;
    },
    onSuccess: () => {
      setSuccess(true);
      openToast({
        show: true,
        heading: 'Success',
        text: 'Password reset link requested successfully!',
        type: 'info',
        timeOut: 5000,
      });
    },
    onError: (err: any) => {
      console.error('Request Reset Password Error:', err); // Log error for debugging
      const errorMessage =
        err?.response?.data?.message ||
        err?.response?.data?.error?.message ||
        'Failed to request a password reset, please try again later';
      openToast({
        show: true,
        heading: 'Sorry',
        text: errorMessage,
        type: 'error',
        timeOut: 5000,
      });
    },
  });
};